import React from "react";
import styled from "styled-components";
import CalendarEvent from "../../Models/CalendarEvent";
import ListItemProps from "../../Models/ListItemProps";
import {List, ListItem, ListItemSecondaryAction, ListItemText, Typography} from "@material-ui/core";
import StarIconSelected from "@material-ui/icons/Star";
import markup from "../../Helper/markup";
import SanitizedDateTime from "../../Models/SanitizedDateTime";
import sanitizeDateAndTime from "../../Helper/sanitizeDateAndTime";
import ItemType from "../../Models/ItemType";
import FavoritesButton from "../Buttons/FavoritesButton";

interface EventListItemProps extends ListItemProps<CalendarEvent> {
    showDivider: boolean;
}

interface EventImageProps {
    image: string;
    onClick: () => void;
}

interface EventInfoViewProps {
    onClick: () => void;
    title: string;
    startDate: string;
    startTime: string;
    endTime: string;
    displayFavorite: boolean;
    isFavorite?: boolean;
    onClickFavorite?: () => void
}
const Container = styled(ListItem)`
  background-color: white;
`;

const ContentList = styled(List)`
  width: 100%;
`;

const EventImage = styled.img`
  width: 100%;
  border-radius: 4px;
`;

const StarIcon = styled(StarIconSelected)`
  fill: #D45D00 !important;
`;

const EventImageView = (props: EventImageProps) => {
    const {image, onClick} = props;
    return (
        <ListItem
            button
            onClick={onClick}
        >
            <EventImage src={image} />
        </ListItem>
    );
};

const EventInfoView = (props: EventInfoViewProps) => {
    const {
        title,
        startDate,
        startTime,
        endTime,
        displayFavorite,
        onClick,
        onClickFavorite,
        isFavorite
    } = props;

    return (
        <ListItem
            button
            onClick={onClick}
        >
            <ListItemText
                primary={
                    <Typography dangerouslySetInnerHTML={markup(title)} />
                }
                secondary={`${startDate}, ${startTime} - ${endTime}`}
            />
            <ListItemSecondaryAction>
                { displayFavorite && onClickFavorite &&
                    <FavoritesButton onClick={() => {
                        if (onClickFavorite)
                            onClickFavorite()
                    }} selected={!!isFavorite} />
                }
            </ListItemSecondaryAction>
        </ListItem>
    );
};

const EventListItem = (props: EventListItemProps) => {
    const {item, showDivider, onClick, onClickFavorite, onClickFavoriteItem, isFavorite, displayFavorite} = props;
    const onClickLocal = () => {
        if (onClick)
            onClick(item);
    };

    const dateTime: SanitizedDateTime = sanitizeDateAndTime(item);

    const localOnClickFavorite = () => {
        if (onClickFavorite)
            onClickFavorite(`${item.id}`, ItemType.Event);

        if (onClickFavoriteItem)
            onClickFavoriteItem(item);
    }

    return (
            <Container disableGutters divider={showDivider}>
                <ContentList disablePadding>
                    {item.image && item.image != '' &&
                        <EventImageView image={item.image} onClick={onClickLocal} />
                    }
                    <EventInfoView
                        onClick={onClickLocal}
                        title={item.title}
                        startDate={dateTime.startDate}
                        startTime={dateTime.startTime}
                        endTime={dateTime.endTime}
                        displayFavorite={displayFavorite}
                        isFavorite={!!isFavorite}
                        onClickFavorite={localOnClickFavorite}
                        />
                </ContentList>
            </Container>
    );
};

export default EventListItem;